module.exports = __webpack_public_path__ + "static/media/companies-white.78db63a9.svg";